import React from "react";
import PropTypes from "prop-types";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteForever";

import { getPrettyMimeTypeName } from "~/constants/mime-types";
import { materialType } from "~/constants/prop-types";

import { isUploadedState, getDocumentUrl, getAttachmentUrl } from "~/libs/upload";

const renderTableRow =
  ({ url, editable, onDelete }) =>
  ({ name, status, payload }) =>
    (
      <TableRow key={name}>
        <TableCell>
          {isUploadedState({ status }) ? (
            <a rel="noopener noreferrer" target="_blank" href={getAttachmentUrl(url, name)}>
              {name}
            </a>
          ) : (
            name
          )}
        </TableCell>
        <TableCell>{getPrettyMimeTypeName(payload.content_type)}</TableCell>
        {editable && <TableCell>{status}</TableCell>}
        {editable && (
          <TableCell>
            <IconButton onClick={onDelete(name)} size="large" aria-label="löschen">
              <DeleteIcon />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
    );

function AttachmentsTable({ attachments, onDelete, editable, material }) {
  const url = getDocumentUrl(material._id);
  const values = Object.values(attachments);

  return (
    <Table aria-label="Anhangtabelle">
      <TableHead>
        <TableRow>
          <TableCell>Anhang</TableCell>
          <TableCell>Typ</TableCell>
          {editable && <TableCell>Status</TableCell>}
          {editable && <TableCell>Löschen</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>{values.map(renderTableRow({ url, editable, onDelete }))}</TableBody>
    </Table>
  );
}

AttachmentsTable.propTypes = {
  attachments: PropTypes.object,
  onDelete: PropTypes.func,
  editable: PropTypes.bool,
  material: materialType
};

export default AttachmentsTable;
